import { queryOptions } from '@tanstack/react-query';
import { getProductDetail } from '~/apis/pms';

export type ProductDetail = Awaited<ReturnType<typeof getProductDetail>>['data'];

/** 메루카리 상품상세 조회를 위한 쿼리 옵션 */
type Params = {
  pid: string;
  uid: number;
  token?: Nullable<string>;
};

export const fetchProductDetail = ({ pid, uid = -1, token }: Params) => {
  const numberedPid = Number(pid);

  return getProductDetail(
    {
      pid: numberedPid,
      viewerUid: uid,
    },
    {
      ...(token && {
        headers: {
          'X-BUN-AUTH-TOKEN': token,
        },
      }),
    },
  );
};

export const productDetailOptions = (params: Params) => {
  const queryKey = ['product', 'getMercariProductDetail', params.pid];
  const options = queryOptions({
    queryKey,
    queryFn: () => fetchProductDetail(params),
    select: (response) => response.data,
    enabled: Boolean(params.pid),
    staleTime: 1000 * 3,
    retry: 0,
    throwOnError: true,
  });

  return options;
};
